import CalenderSvg from "../assets/icons/calendar.svg";
import MoneySvg from "../assets/icons/money.svg";
import DiscountSvg from "../assets/icons/discount-shape.svg";

export const GLOBAL_CONSTANTS = {
  FORGOT_PWD: "Forgot Password?",
  RECOVER_PWD: "Forgot / Resend Password",
  NEW_USER: "New User?",
  COUNTRY_CODE: "+91",
  COMPLETE_KYC_TXT: "Complete KYC Verification",
  KYC_UNDER_REVIEW_TXT:
    "KYC under review. You will be notified once it's done!",
  SLA_NOT_SIGNED_TXT: "SLA is not Signed",
  NDA_NOT_SIGNED_TXT: "NDA is not Signed",
  SIGN_SLA_AND_NDA_TXT: "Please Sign the SLA and NDA Documents.",
  SIGN_SLA_ONLY_TXT: "Please Sign the SLA Document.",
  SIGN_NDA_ONLY_TXT: "Please Sign the NDA Document.",
  ALREADY_HAVE_ACC: "Already have an Account?",
  REVIEW_MSG_TITLE: "Review in Progress",
  REVIEW_MSG_DESC:
    "We are reviewing your documents. Please visit again after some time.",
  SUCCESS: "success",
  KYC_SUCCESS_MSG: "Your KYC process has been successfully completed.",
  SUPPORT_EMAIL: "support@karncy.com",
  WHATSAPP_NUM: "9703676999",
  EMPTY_DASH_TITLE_TXT: "Your Dashboard is empty. Start investing today!",
  EMPTY_DASH_DESC_TXT:
    "Investors have gained strong returns through high-value deals, making Karncy a trusted platform for profitable investments.",
  DEALS_BANNER_TXT1: "Investors are actively funding high-value deals,",
  DEALS_BANNER_TXT2: "reflecting strong confidence in the Karncy platform.",
  MIN_AMT_TO_INV_TXT: "A Minimum of ₹2,00,000 Required to invest in deals.",
  SHARE_TXT: "Share details via",
  WHATSAPP: "WhatsApp",
  EMAIL: "Poc Email",
  WAL_BAL: "Wallet Balance",
  MIN_BAL_TO_BUY_DEAL: 200000,
  STAT_PEN_ID: "USM1000007",
  STAT_KYC_PEN_ID: "USM1000008",
  STAT_KYC_REVIEW_ID: "USM1000010",
  STAT_KYC_VERIFIED_ID: "USM1000009",
  STAT_ACTIVE_ID: "USM1000001",
  KAR_NAME: "Karta Name",
  NAME_AS_PER_PAN: "Contact Name",
  KAR_EMAIL: "Karta Email",
  KAR_PH_NUM: "Karta Phone Number",
  PH_NUM: "Poc Phone Number",
  PRIM_ADD: "Primary Address",
  DESGINATION: "Designation",
  COMM_ADD: "Address for Communication",
  NA: "Not Available",
  COMP_NAME: "Business Name",
  COMP_EMAIL: "Company Email",
  COMP_PH_NUM: "Company Phone Number",
  DESIG: "Designation",
  IND_TYPE: "Industry Type",
  COMP_TYPE: "Business Type",
  ANN_TURN: "Annual Turnover",
  COMP_REG_ADD: "Business Registered Address",
  ADDITIONAL_REF_LINKS: "Additional Reference Links",
  REF_LINK: "Link",
  LINK_DESC: "Link Description",
  DIR_NAME: "Director Name",
  DOB: "Date of Birth",
  DIR_EMAIL: "Director Email",
  DIR_PH_NUM: "Director Phone Number",
  HUF_NAME: "HUF Name",
  HUF_EMAIL: "HUF Email",
  HUF_PH_NUM: "HUF Phone Number",
  HUF_REG_ADD: "HUF Registered Address",
  DEL: "Delete",
  DEL_BANK_CONFIRM: "Are you sure you want to delete this bank account?",
  MARK_AS_PRI: "Mark as Primary",
  ACC_NUM: "Account Number",
  ACC_HOL_NAME: "Account Holder Name",
  ACC_IFSC: "Account IFSC",
  BRA_NAME: "Branch Name",
  PRIM_BANK: "PRIMARY BANK",
  CONCENT_PROV:
    "I provide my consent to karncy to verify my bank details and store in this platform",
  TERMS_COND_PRIV_POL:
    "I here by read and accept Terms and Conditions, Refund Policies and Privacy Policies",
  COMP_PAN: "Company PAN",
  COMP_GSTIN: "Company GSTIN",
  COMP_BANK_ACC: "Company Bank Account",
  DIR_PAN: "Director PAN",
  DIR_AADHAR: "Director Aadhar",
  PAN: "PAN",
  HUF_PAN: "HUF PAN",
  KAR_PAN: "Karta PAN",
  AADHAR: "Aadhar",
  BANK_ACC: "Bank Account",
  SLA: "SLA",
  NOM_LEG_NAME: "Nominee Legal Name",
  NOM_DOB: "Nominee Date of Birth",
  RELSHIP: "Relationship",
  WEBSITE: "Website",
  CREDIT_TENURE: "Credit Tenure",
  CREDIT_AMT: "Requested Credit Amount",
  AMT_TO_RAISE: "Amount To Raise",
  INC_DATE: "Incorporation Date",
  MULTIPLE_GST: "Has Multiple GSTIN?",
  BUS_DESC: "Business Description",
  FIN_SUMMARY: "Financial Summary",
  COMMENTS: "Comments",
};

export const GEN_TEXT = {
  INVO_FOR_ENT: "Enterprise",
  INVO_FOR_BUS: "Business",
  TENURE: "Tenure:",
  INVO_FILE: "InvoiceFile",
  TERMS: "Terms",
  PRIVACY: "Privacy",
};

export const BTN_TXT = {
  LOGIN: "Login",
  SIGNUP: "Sign Up",
  SEND_OTP: "Send OTP",
  BACK: "Back",
  CHANGE: "Change",
  RESEND_OTP: "Resend OTP",
  NEXT: "Next",
  SUBMIT: "Submit",
  SHARE: "Share",
  ADD_MON: "Add Money",
  MORE: "More",
  PROFILE: "Profile",
  BANK_DET: "Bank Details",
  CHNG_PWD: "Change Password",
  LOGOUT: "Logout",
  COMPLETE_NOW: "Complete Now",
  SIGN_SLA: "Sign SLA",
  SIGN_NDA: "Sign NDA",
  SKIP: "Skip",
  COMPLETE: "Complete",
  PROCEED_FURTHER: "Proceed Further",
  MAYBE_LATER: "May be Later",
  LETS_START_BTN_TEXT: "Let's get started!",
  SUP_FAQ: "Support & FAQ",
  PRI_POL: "Privacy Policy",
  TERM_COND: "Terms and Conditions",
  REFUND_POL: "Refund Policy",
  VERIFY_OTP: "Verify OTP",
  VERIFY: "Verify",
  ADD_NEW_BANK: "Add New Bank",
  SAVE: "SAVE",
  EDIT: "Edit",
  VIEW_ALL: "View All",
  CLICK_HERE: "Click here",
  TO_VIEW_DETAILS: "to view the details",
  SAVE_CHNG: "Save Changes",
  SAVE_ADD: "Save Address",
  EXP_DEALS: "Explore Deals",
  READ_LESS: "Read Less",
  READ_MORE: "Read More",
  UPLOAD_INV: "Upload Invoice",
  UPLOAD_SCF: "Upload Purchase Order",
  DWNLD_SUM_TEMP: "Download Summary Template",
  UPLOAD_SUM_FILE: "Upload Summary File",
  VALIDATE_SUM: "Validate Summary",
  UPLOAD_DOC_ZIP: "Upload Documents ZIP",
  TRANSFER: "Transfer",
  PAY_NOW: "Pay Now",
  DOWNLOAD: "Download",
  DWNLD_INV_CSV: "Download Invoices CSV",
  DWNLD_INV_ZIP: "Download Invoices Zip",
  DWNLD_PO_CSV: "Download Purchase Order CSV",
  DWNLD_PO_ZIP: "Download Purchase Order Zip",
  CANCEL: "Cancel",
  DELETE: "Delete",
  PRO_WITH_DIGI: "Proceed with Digilocker",
  FETCH_AADHAAR_PAN: "Fetch Aadhaar & PAN",
};

export const TITLE_TXT = {
  WELCOME_TEXT: "Welcome to Karncy",
  OTP_TITLE: "Enter the OTP",
  CHNG_PWD_TITLE: "Change Password",
  SIGNUP_AS_TITLE: "I want to sign up as ..",
  INV: "Investor",
  VEN: "Vendor",
  ENROLL_AS: "Enroll me as a...",
  LETS_GET_START_TEXT: "Let's get started!",
  RM_DET_TXT: "Your RM Details",
  DEAL_BOOKED: "Deal Booked",
  DEAL_EXEC: "Deal Executed",
  DEAL_DIS: "Deal Disbursed",
  REPAYMENT: "Repayment",
  REPAID: "Repaid",
  ECW_DET_TXT: "Your Virtual Account Details",
  ECW_BEN_ACC_NAME: "Beneficiary Account Name",
  ECW_BANK_NAME: "Virtual Account Bank Name",
  ECW_BRANCH_NAME: "Virtual Account Branch Name",
  ECW_BANK_ACC_NUM: "Virtual Account Number",
  ECW_IFSC_CODE: "Virtual Account IFSC Code",
  DEPO_DET_TO_EMAIL_CONFIRM_TXT:
    "Are you sure you want to send the deposit details to your email?",
  DEPO_DET_TO_WHATSAPP_CONFIRM_TXT:
    "Are you sure you want to send the deposit details to your Whatsapp?",
  REVIEW_INFO_TITLE: "We are reviewing your documents",
  PER_DETS: "User Details",
  KAR_DETS: "Karta Details",
  COMP_DETS: "Company Details",
  AUTH_SIG: "Company Details",
  HUF_DETS: "HUF Details",
  BANK_DETS: "Bank Details",
  ADD_NEW_BANK_DETS: "Add New Bank Details",
  ECW_DETS: "Virtual Account Details",
  KYC_DETS: "KYC Details",
  NOM_DETS: "Nominee Details",
  BUS_DETS: "Business Details",
  ADD_VERIFY: "Address Verification",
  CONTACT_DETS: "Contact Details",
  DIR_KYC: "Director KYC",
  ADDITIONAL_INFO: "Additional Information",
  COMM_ADD: "Communication Address",
  BANK_VERIFY: "Bank Verification",
  ADD_NOM_DETS: "Add your Nominee Details",
  EDIT_NOM_DETS: "Edit your Nominee Details",
  YOUR_DASH: "Your Dashboard",
  IND_INV: "Industries you have invested",
  BUS_ENT_ESCW_ACC_DETS: "Business Enterprise Virtual Account Details",
  INV_UPLOAD: "Invoice Upload",
  INV_UPLOAD_STEP_1: "STEP 1 - Upload Invoice Summary Sheet",
  PO_UPLOAD: "Purchase Order Upload",
  PO_UPLOAD_STEP_1: "STEP 1 - Upload Purchase Order Summary Sheet",
  DOC_SUB_SUC: "Documents Submitted Successfully",
  DEALS: "Deals",
  DEAL_DETS: "Deal Details",
  DEAL_LEVEL_FUND: "Deal Level Funding",
  DEAL_LEVEL_SETTLE: "Deal Level Settlement",
  TQ: "Thank you!",
  SETTLEMENT: "Settlement",
};

export const DESC_TXT = {
  ECW_DET_TXT:
    "Please transfer amount to your Virtual account to start investing",
  FORGOT_PWD_INFO_TEXT:
    "Enter your user account's verified email address and we will send an otp to that email.",
  RECOVER_PWD_INFO_TEXT:
    "Enter your registered email address. If you have not completed your first login yet, we will resend your onboarding password. Otherwise we will send an OTP to reset it.",
  OTP_INFO_TEXT:
    "If you have not received the OTP in your inbox, please check your Junk/Spam folder as well.",
  EMAIL_UPDATED_RELOGIN:
    "Your email was updated successfully. Please sign in with your new email address.",
  POC_DIRECTOR_NOTE:
    "The POC Name, POC Phone Number, and POC Email ID must be the details of a Director of the business.",
  INV_DESC:
    "Grow your money while supporting businesses! Fund invoices and earn returns as businesses repay.",
  VEN_DESC:
    "Need quick cash flow for your business? Sell your invoices, get instant funds, and keep growing",
  RM_DET_NOT_AVAIL: "RM details not available",
  AWAT_APP_BY_BUS: "Awaiting approval by Karncy",
  AWAT_SIGN_AGG: "Awaiting Business & Karncy sign-off",
  REVIEW_INFO_DESC: "Please visit again after some time.",
  BANK_DETS_NOT_AVAIL: "Bank details not available",
  ECW_DETS_NOT_AVAIL: "Virtual Account details not available",
  INV_UPLOAD_STEP_1:
    "Submit invoice details in Excel (XLSX) or CSV format using the sample template.",
  PO_UPLOAD_STEP_1:
    "Submit Purchase Order details in Excel (XLSX) or CSV format using the sample template.",
  DOC_SUB_SUC:
    "Your invoice summary and supporting documents have been submitted. We will review your request and notify you shortly regarding the next steps.",
  PO_DOC_SUB_SUC:
    "Your purchase order summary and supporting documents have been submitted. We will review your request and notify you shortly regarding the next steps.",
  LETS_GET_START:
    "Provide your business details to begin your journey with us.",
};

export const SUCCESS_MSGS = {
  ECW_DET_SUC_MSG: "Virtual Account details sent to registered email Sucessfully!",
  JV_SIGNUP_SUCCESS: "Joint Ventures business signup completed successfully.",
  ID_SIGNUP_SUCCESS: "Invoice Financing business signup completed Successfully",
  DEAL_REQUEST_SUCCESS: "Deal Request Submitted Successfully.",
  QUESTIONNAIRE_SUBMITTED_SUCCESS: "Questionnaire answer submitted successfully.",
  INVOICE_SUBMITTED_SUCCESS: "Invoice upload completed successfully.",
  WITHDRAW_SUCCESS: "Business Withdrawn Successfully.",
};

export const ERROR_MSGS = {
  SESSION_ELSEWHERE:
    "You have been logged out because your account was signed in elsewhere.",
  EMAIL_ERR_MSG: "Email cannot be empty!",
  PWD_ERR_MSG: "Password cannot be empty!",
  DESIGNATION_ERR_MEG: "Designation cannot be empty!",
  BANK_KYC_ERR_MSG: "Please Complete your bank verification later",
  ENTER_CURR_PWD_ERR_MSG: "Please enter your current password!",
  ACC_NUM_ERR_MSG: "Account numbers do not match!",
  ACCP_CONCENT_ERR_MSG: "You must agree to the consent letter!",
  ENTER_NOM_DOB: "Please enter Nominee DOB!",
  SEL_REL: "Please select your relationship!",
  ACCP_TER_CON: "You must accept the terms and conditions!",
  SEL_STATE: "Please select State!",
  SEL_IND_TYPE: "Please select Industry Type!",
  SEL_ANN_TURN: "Please select Annual Turnover!",
  SEL_COMP_TYPE: "Please select Company type!",
  BUS_DESCRIPTION_ERR_MSG: "Business Description Cannot be empty!",
  FINANCIAL_SUMMARY: "Financial Summary Cannot be empty!",
  COMMENTS: "Comments Cannot be empty!",
  EXP_AMT_ERR_MSG: "Expected amount cannot be empty!",
  ENTER_INC_DATE: "Please select Incorporation Date",
  SEL_DEAL_TYPE_ERR_MSG: "Please select Deal Type",
  SEL_EXP_DAYS_ERR_MSG: "Please select Expiry Days",
};

export const YESORNO = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const USERTYPE_ID = {
  INDIVIDUAL: "UTY1000001",
  HUF: "UTY1000002",
  COMPANY: "UTY1000003",
};

export const ABOUT_KARNCY = {
  KARNCY_USERS_DESC_LOGIN: "Empowering Businesses with Fast, Flexible Funding",
  KARNCY_USERS_DESC_SIGNUP: "Get Instant Access to Working Capital...",
  ABOUT_LIST_DATA: [
    {
      title: "Get quick approvals and faster fund disbursement",
      icon: CalenderSvg,
    },
    {
      title: "Bridge cash flow gaps with upfront access to unpaid invoices",
      icon: MoneySvg,
    },
    {
      title: "Focus on growth while we handle the capital",
      icon: DiscountSvg,
    },
  ],
};

export const INV_TEMP_DATA = [
  {
    invNum: "INV123456",
    invAmt: 200000,
    invDate: "2023-10-23",
    invDueDate: "2023-10-26",
  },
  {
    invNum: "INV456123",
    invAmt: 500000,
    invDate: "2023-11-01",
    invDueDate: "2023-11-04",
  },
];

export const SCF_TEMP_COL = [
  { header: "PO Number", key: "poNum" },
  { header: "PO Amount", key: "poAmt" },
  { header: "Material Cost", key: "matCost" },
  { header: "PO Date", key: "poDate" },
  { header: "PO Due Date", key: "poDueDate" },
];

export const SCF_TEMP_DATA = [
  {
    poNum: "PO123456",
    poAmt: 200000,
    matCost: 150000,
    poDate: "2023-10-23",
    poDueDate: "2023-10-26",
  },
  {
    poNum: "PO456123",
    poAmt: 500000,
    matCost: 400000,
    poDate: "2023-11-01",
    poDueDate: "2023-11-04",
  },
];

export const INV_TEMP_COL = [
  { header: "Invoice Number", key: "invNum" },
  { header: "Invoice Amount", key: "invAmt" },
  { header: "Invoice Date", key: "invDate" },
  { header: "Invoice Due Date", key: "invDueDate" },
];

export const DEAL_STATUS_LABEL_MAP = {
  pending: "Pending Deals",
  ongoing: "Ongoing Deals",
  closed: "Closed Deals",
  expired: "Expired Deals",
  rejected: "Rejected Deals",
  cancelled: "Cancelled Deals",
  settled: "Settleted Deals",
};

export const DEAL_STATUS_KEYS = {
  ONGOING: "ongoing",
  AGREEMENT: "agreement",
  DISBURSED: "disbursed",
  REPAID: "repaid",
  PENDING_DISBURSAL: "pending disbursal",
  SETTLED: "settled",
};

export const DEAL_STATUS_IDS = {
  PARTIALLY_SETTLED: "DSC1000009",
};

export const DEAL_DETAIL_TABS = {
  DETAILS: "dealDetails",
  FUNDING: "dealLevelFunding",
  SETTLEMENT: "dealLevelSettlement",
};

export const DEAL_DETAIL_FUNDING_VISIBLE_KEYS = new Set([
  DEAL_STATUS_KEYS.AGREEMENT,
  DEAL_STATUS_KEYS.DISBURSED,
  DEAL_STATUS_KEYS.REPAID,
  DEAL_STATUS_KEYS.PENDING_DISBURSAL,
  DEAL_STATUS_KEYS.SETTLED,
]);

export const DEAL_DETAIL_SETTLEMENT_VISIBLE_KEYS = new Set([
  DEAL_STATUS_KEYS.REPAID,
  DEAL_STATUS_KEYS.SETTLED,
]);

export const DEAL_DETAIL_PAY_NOW_SELECTED_STATUSES = new Set([
  DEAL_STATUS_KEYS.ONGOING,
]);

export const DEAL_DETAIL_PAY_NOW_DEAL_STATUSES = new Set([
  DEAL_STATUS_KEYS.DISBURSED,
  DEAL_STATUS_KEYS.REPAID,
]);

export const DEAL_DETAIL_DOWNLOAD_FALLBACK = "invoice";

export const DEAL_DETAIL_MODAL_WIDTH = 650;

export const FAQ = {
  Q1: {
    Q: "How does invoice financing work on Karncy?",
    A: "Invoice financing allows businesses to raise funds by selling their unpaid invoices on the Karncy platform. Approved investors or financial institutions purchase the invoices, and businesses receive instant liquidity instead of waiting for payment cycles to close. ",
  },
  Q2: {
    Q: "Is there a minimum or maximum limit for raising funds? ",
    A: "Yes, the funding limit depends on your business profile, invoice size, and creditworthiness. The minimum and maximum limits will be shared with you post profile evaluation. ",
  },
  Q3: {
    Q: "How secure is the Karncy platform for transactions? ",
    A: "Karncy uses industry-standard encryption, secure APIs, and complies with relevant regulatory norms to ensure that your data and transactions remain fully protected. ",
  },
  Q4: {
    Q: "How long does it take to receive funds once an invoice is uploaded? ",
    A: "Once your invoice is verified and approved, funds are generally disbursed within 24 to 48 hours. ",
  },
  Q5: {
    Q: "Can I track my invoices and transactions on the platform?  ",
    A: "Yes, our user-friendly dashboard provides real-time tracking of your invoices, funded transactions, repayment schedules, and other analytics.  ",
  },
  Q6: {
    Q: "How does repayment work?    ",
    A: "The buyer makes the payment directly to the financier through Karncy’s escrow account. If the buyer defaults, the seller (your business) may need to repay as per agreed terms.  ",
  },
  Q7: {
    Q: "Can I exit the platform if I change my mind?   ",
    A: "Yes, businesses can exit by clearing any ongoing obligations or pending repayments. You’ll need to send an official exit request to our support team.  ",
  },
  Q8: {
    Q: "What if my business needs higher limits later? ",
    A: "You can request a re-evaluation based on your updated financials or transaction history. If approved, your funding limit can be increased.  ",
  },
};

export const SOCIAL_MEDIA_LINKS = {
  FB: "https://www.facebook.com/share/16QqocZRC6/",
  X: "https://x.com/Karncyfintech",
  LI: "https://www.linkedin.com/company/karncy",
};

export const filterOptions = [
  { optionId: "1", optionLabel: "Bank Withdraw" },
  { optionId: "2", optionLabel: "Virtual Account Deposit" },
  { optionId: "3", optionLabel: "Virtual Account Internal Transfer" },
];

